import { DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { AuthService } from './shared/services/auth.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, DatePipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  today = new Date();
  showCopy = signal(true);

  private authService = inject(AuthService);
  private router = inject(Router);

  isAuth = this.authService.isAuthenticated;

  constructor (themeService: ThemeService) {
    themeService.loadTheme();

    this.authService.init().subscribe(_ => {
      if (this.authService.isAuthenticated() && this.router.url === '/auth/login') {
        this.router.navigate(['/']);
      }
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showCopy.set(event.urlAfterRedirects !== '/chat');
      });
  }
}
